import apiClient from '../clienteFebosAPI';

const RESOURCE = '/configuracion';

export const clOpcionesEmpresaList = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/portales/${payload.dominio}/opciones?${params}`, {
    operacionId: 'io.obtener.opciones.request.externo'
  });
};

export const ioGetSettings = ({ parameters = [] }) => {
  const params = apiClient.queryParams({ parametros: parameters.join(',') });
  return apiClient.get(`/v2/herramientas/configuraciones?${params}`, {
    operacionId: 'io.get.settings',
    permiso: 'ADM46'
  });
};
